module.exports = "body {\r\n    background: #fff !important;\r\n}\r\n\r\n.terms .card-header img {\r\n    width: 200px;\r\n}\r\n\r\n.terms .card-header {\r\n    padding: .0rem 1.25rem;\r\n}\r\n\r\n.terms .card-header {\r\n    background: #353535;\r\n}\r\n\r\n.terms .card-header h5 {\r\n    color: #fff;\r\n}\r\n\r\n.terms .card-body h5 {\r\n    border-bottom: 2px solid #00adee;\r\n    padding-bottom: 5px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/terms-sat/terms-sat.component.css
// module id = ./src/app/terms-sat/terms-sat.component.css
// module chunks = main